import React from "react";

const DashboardPage = () => {
  return <div>Dashboard in progress...</div>;
};

export default DashboardPage;
